import type { StateCreator } from 'zustand';
import type { SliceMutators } from '~/store/mutators';
import type { Rect } from '~/types/pipeline';

export type WatermarkSlice = {
  watermark: {
    region: Rect | null;
    enabled: boolean;
    useOpencv: boolean;
  };
  setWatermarkRegion: (r: Rect) => void;
  setWatermarkEnabled: (b: boolean) => void;
  setUseOpencv: (b: boolean) => void;
  resetWatermark: () => void;
};

const INITIAL_WATERMARK = {
  region: null,
  enabled: false,
  useOpencv: false,
} satisfies WatermarkSlice['watermark'];

export const createWatermarkSlice: StateCreator<
  WatermarkSlice,
  SliceMutators,
  [],
  WatermarkSlice
> = (set) => ({
  watermark: INITIAL_WATERMARK,
  setWatermarkRegion: (r) =>
    set((s) => {
      s.watermark.region = r;
    }),
  setWatermarkEnabled: (b) =>
    set((s) => {
      s.watermark.enabled = b;
    }),
  setUseOpencv: (b) =>
    set((s) => {
      s.watermark.useOpencv = b;
    }),
  resetWatermark: () =>
    set((s) => {
      s.watermark = { ...INITIAL_WATERMARK };
    }),
});
